import { auth } from '../../config/firebaseConfig';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

export const googleSignIn = async () => {
	try {
		const provider = new GoogleAuthProvider();
		const result = await signInWithPopup(auth, provider);

		const user = result.user;
		const token = await user.getIdToken();

		return {
			uid: user.uid,
			email: user.email,
			token: token,
		};
	} catch (error: any) {
		const errorCode = error.code;
		const errorMessage = error.message;

		console.error('Error during Google sign-in:', errorCode, errorMessage);
		throw new Error(`Google sign-in error: ${errorCode} - ${errorMessage}`);
	}
};
